export const bannerQueryKeys = {
    all: ['fields'] as const,
    lists: () => [...bannerQueryKeys.all, 'list'] as const,
    list: (filters: object) => [...bannerQueryKeys.lists(), filters] as const,
    details: () => [...bannerQueryKeys.all, 'detail'] as const,
    detail: (id: string, typeId: string) => [...bannerQueryKeys.details(), id, typeId] as const,
};
